var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutgoing = function SvgOutgoing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.1 11.9",
    style: {
      enableBackground: "new 0 0 12.1 11.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n\t\tOutgoing Call Icon\n\t")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.000000, -538.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6,15.7l7.6-7.4l0,4.7c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3l0.7,0 c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6l0-8c0-0.2-0.1-0.4-0.3-0.6C15.7,4.1,15.4,4,15.2,4L7,4C6.8,4,6.6,4.1,6.4,4.3 C6.2,4.4,6.2,4.6,6.2,4.9l0,0.7c0,0.2,0.1,0.4,0.3,0.6C6.6,6.4,6.8,6.4,7,6.4l4.8,0l-7.6,7.5c-0.3,0.3-0.3,0.9,0,1.2l0.5,0.5 C5.1,16,5.7,16,6,15.7L6,15.7z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutgoing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outgoing.6f511f5e.svg";
export { ForwardRef as ReactComponent };